<app-progress-bar></app-progress-bar>
<app-progress-spinner></app-progress-spinner>
<app-toast></app-toast>
<router-outlet></router-outlet>
